import { connect } from 'react-redux';
import Abstract from './abstract';
import fetchAbstract from '../../../shared/actions/fetchers/fetchAbstract';

function findAbstract(
  abstracts,
  {
    pii: piiId, scopusEid, doi: doiId,
  },
) {
  const { pii = {}, doi = {}, eid = {} } = abstracts;
  const { isLoading, failed, data } = pii[piiId]
  || eid[scopusEid]
  || doi[doiId]
  || {};

  return { isLoading, failed, data };
}

const mapStateToProps = (
  { abstracts },
  { pii, scopusEid, doi },
) => findAbstract(abstracts, { pii, scopusEid, doi });

const mapDispatchToProps = (
  dispatch,
  { pii, scopusEid, doi },
) => ({
  fetchAbstract: () => dispatch(fetchAbstract({ pii, eid: scopusEid, doi })),
});

export default connect(mapStateToProps, mapDispatchToProps)(Abstract);
